/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _extends = require('babel-runtime/helpers/extends')['default'];

var _objectWithoutProperties = require('babel-runtime/helpers/object-without-properties')['default'];

exports.__esModule = true;
exports['default'] = clientMiddleware;

function clientMiddleware(client) {
	return function (_ref) {
		var dispatch = _ref.dispatch;
		var getState = _ref.getState;

		return function (next) {
			return function (action) {
				if (typeof action === 'function') {
					return action(dispatch, getState);
				}

				var promise = action.promise;
				var types = action.types;

				var rest = _objectWithoutProperties(action, ['promise', 'types']);

				if (!promise) {
					return next(action);
				}

				var REQUEST = types[0];
				var SUCCESS = types[1];
				var FAILURE = types[2];

				next(_extends({}, rest, { type: REQUEST }));

				return promise(client).then(function (result) {
					return next(_extends({}, rest, { result: result, type: SUCCESS }));
				}, function (error) {
					return next(_extends({}, rest, { error: error, type: FAILURE }));
				})['catch'](function (error) {
					console.error('MIDDLEWARE ERROR:', error);
					next(_extends({}, rest, { error: error, type: FAILURE }));
				});
			};
		};
	};
}

module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/middleware/clientMiddleware.js
 ** module id = 717
 ** module chunks = 0
 **/